import { render, staticRenderFns } from "./HuayDashboard.vue?vue&type=template&id=67b6d300&"
import script from "./HuayDashboard.vue?vue&type=script&lang=js&"
export * from "./HuayDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HuayDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports